export default function () {
  return {
    nonceWarmup: {},
    certificado: {},
    solicitacaoExterna: {},
    arquivo: {},
  };
}
